import Eyebrow from './Eyebrow'
import eyebrowStyles from './Eyebrow.module.css'
import styles from './SectionLabel.module.css'

interface SectionLabelProps {
  children: React.ReactNode
  action?: { label: string; onClick: () => void }
  large?: boolean
}

export default function SectionLabel({ children, action, large }: SectionLabelProps) {
  return (
    <div className={styles.label}>
      <Eyebrow className={large ? eyebrowStyles.large : undefined}>{children}</Eyebrow>
      {action && (
        <button type="button" className={styles.link} onClick={action.onClick}>
          {action.label}
        </button>
      )}
    </div>
  )
}
